export const PAGE_SIZE_DEFAULT = 20;

export const PAGE_NUMBER_DEFAULT = 1;

export const DEFAULT_COUNT = 0;

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_SEARCH_TEXT = '';

export const defaultPageRequest = {
    pageNumber: DEFAULT_PAGE_NUMBER,
    pageSize: DEFAULT_PAGE_SIZE,
    searchText: DEFAULT_SEARCH_TEXT
};
